import DOMPurify from 'dompurify';
import { MEDIA_BUNDLE_PREFIX, CHAT_LINK_PREFIX, CHAT_LINK_SUFFIX, DOWNLOAD_SHARE_PREFIX, DOWNLOAD_SHARE_SUFFIX } from '../constants';

export const isEditableMessage = (msg) => typeof msg?.message === 'string'
    && !msg.is_deleted
    && !msg.message.startsWith(MEDIA_BUNDLE_PREFIX)
    && !msg.message.startsWith(CHAT_LINK_PREFIX)
    && !msg.message.startsWith(DOWNLOAD_SHARE_PREFIX);

export const parseDownloadShare = (message) => {
    if (typeof message !== 'string' || !message.startsWith(DOWNLOAD_SHARE_PREFIX)) return null;
    try {
        const data = JSON.parse(message.slice(DOWNLOAD_SHARE_PREFIX.length, message.length - DOWNLOAD_SHARE_SUFFIX.length));
        const id = Number(data.id);
        if (!Number.isSafeInteger(id) || id <= 0) return null;
        return {
            id,
            text: String(data.text || '다운로드 파일').slice(0, 200),
            size: Number.isFinite(data.size) ? data.size : null,
            updatedAt: typeof data.updatedAt === 'string' ? data.updatedAt : null,
            external: !!data.external,
            note: typeof data.note === 'string' ? data.note.slice(0, 500) : '',
        };
    } catch { return null; }
};

// 복사·알림 미리보기용 순수 텍스트 (멘션 태그 → @닉네임, HTML 제거)
export const plainTextOf = (msg) => {
    const raw = typeof msg?.message === 'string' ? msg.message : '';
    if (raw.startsWith(MEDIA_BUNDLE_PREFIX)) return '(사진/동영상)';
    if (raw.startsWith(CHAT_LINK_PREFIX)) {
        try {
            const link = JSON.parse(raw.slice(CHAT_LINK_PREFIX.length, raw.length - CHAT_LINK_SUFFIX.length));
            return `#${link.channelName} ${link.username}: ${String(link.message || '').replace(/<[^>]*>/g, '')}`;
        } catch { return '(메시지 링크)'; }
    }
    const share = parseDownloadShare(raw);
    if (share) return `📦 ${share.text}${share.note ? `\n${share.note}` : ''}`;
    const withMentions = raw.replace(/@\[[^|\]]+\|([^\]]+)\]/g, '@$1');
    // 파일 링크 등 HTML 이 섞인 메시지는 태그를 걷어낸다
    if (/<[a-z][\s\S]*>/i.test(withMentions)) {
        const div = document.createElement('div');
        div.innerHTML = DOMPurify.sanitize(withMentions);
        return div.textContent.trim();
    }
    return withMentions;
};

export const copyToClipboard = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch {
        const el = document.createElement('textarea');
        el.value = text;
        el.setAttribute('readonly', '');
        el.style.position = 'fixed'; el.style.opacity = '0';
        document.body.appendChild(el);
        el.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(el);
        return ok;
    }
};

export const messageLink = (channelId, messageId) => {
    const url = new URL(window.location.origin + '/');
    url.searchParams.set('ch', channelId);
    url.searchParams.set('msg', messageId);
    return url.toString();
};
